module.exports = __webpack_public_path__ + "cf154a5cd916652f07935b9813a9b22a.png";